import React from 'react';
import PropTypes from 'prop-types';
// import { useNavigate } from 'react-router-dom';
import {
  CourseCardWrapper,
  CourseCardTop,
  CourseLanguage,
  CourseDescription,
  CourseInfoRow,
  CourseInfoItem,
  CourseInfoLabel,
  CourseInfoValue,
  CourseCardBottom,
  CourseButton,
  CourseTitle,
  CoursePrice,
  // CourseExpiry,
} from './CourseCard.styles';
import { Link } from 'react-router-dom';

const CourseCard = ({ course, ip = false }) => {
  const slugify = (name = '') =>
    name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const courseUrl = ip
    ? `/inspectionpal/course/${slugify(course?.courseName)}/${course._id}`
    : `/course/${slugify(course?.courseName)}/${course._id}`;

  return (
    <CourseCardWrapper as={Link} to={courseUrl}>
      <CourseCardTop>
        <CourseLanguage>{course.language || 'English'}</CourseLanguage>

        <CourseTitle>{course.courseName}</CourseTitle>

        {course.description && (
          <CourseDescription>{course.description}</CourseDescription>
        )}

        <CourseInfoRow>
          <CourseInfoItem>
            <CourseInfoLabel>Training</CourseInfoLabel>
            <CourseInfoValue>Online</CourseInfoValue>
          </CourseInfoItem>

          {course.expiryDate !== 0 && (
            <CourseInfoItem>
              <CourseInfoLabel>Certificate</CourseInfoLabel>

              <CourseInfoValue>
                Valid for {course.expiryDate}{' '}
                {course.expiryDate === 1 ? 'year' : 'years'}
              </CourseInfoValue>
            </CourseInfoItem>
          )}

          {course.partTwo && (
            <CourseInfoItem>
              <CourseInfoLabel>Course Type</CourseInfoLabel>
              <CourseInfoValue>Two Part Course</CourseInfoValue>
            </CourseInfoItem>
          )}
        </CourseInfoRow>
      </CourseCardTop>

      <CourseCardBottom>
        <CoursePrice>${course.price}</CoursePrice>

        <CourseButton>
          View Course
          <span aria-hidden="true">→</span>
        </CourseButton>
      </CourseCardBottom>
    </CourseCardWrapper>
  );
};
CourseCard.propTypes = {
  course: PropTypes.object.isRequired,
  ip: PropTypes.bool,
};

export default CourseCard;
